import Vue from 'vue'
import Router from 'vue-router'
import { router } from '@/pages'

Vue.use(Router)

let _routerList = []
for (let i in router) {
  let routerInfo = i.split('.')
  // 模块名
  const modularName = routerInfo[0]
  // 页面名
  const pageName = routerInfo[1]
  // 路由元信息
  const meta = router[i].meta || {}

  _routerList.push({
    path: `/${modularName}/${pageName}`,
    name: `${modularName}.${pageName}`,
    component: r => {
      import(`@/pages/${modularName}/page/${pageName}`).then(module => {
        r(module)
      })
    },
    meta
  })
}

export default new Router({
  routes: [
    { path: '*', redirect: '/Common/Login' },
    ..._routerList
  ]
})
